import { useEffect, useState } from 'react'
import { useDebounceValue } from 'usehooks-ts'
import { Input } from 'routes/components/Shared'
import classes from './ScenariosSearch.module.scss'

export const ScenariosSearch = ({
  value,
  onChange,
}: {
  value: string
  onChange: (value: string) => void
}) => {
  const [localSearch, setLocalSearch] = useState<string>(value)
  const [debouncedValue] = useDebounceValue(localSearch, 300)

  // Sync the input value with the query string on mount or query string change
  useEffect(() => {
    setLocalSearch(value)
  }, [value])

  // Update the query string when the debounced value changes
  useEffect(() => {
    if (debouncedValue !== value) {
      onChange(debouncedValue)
    }
  }, [debouncedValue])

  return (
    <Input
      name='search'
      type='search'
      aria-label='search input'
      value={localSearch}
      onChange={(e) => setLocalSearch(e.target.value)}
      placeholder={'Search scenarios'}
      autoComplete='off'
      hasIcon
      className={classes.wrapper}
    />
  )
}
